import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Briefcase, Home, CalendarDays, FileText, Bell, LogOut, Sparkles, Send } from "lucide-react";

const nav = [
  { to: "/crm", end: true, label: "Dashboard", Icon: LayoutDashboard },
  { to: "/crm/lead-search", label: "AI Lead Search", Icon: Sparkles },
  { to: "/crm/leads", label: "Leads", Icon: Users },
  { to: "/crm/deals", label: "Deals", Icon: Briefcase },
  { to: "/crm/listings", label: "Listings", Icon: Home },
  { to: "/crm/appointments", label: "Appointments", Icon: CalendarDays },
  { to: "/crm/outreach", label: "Outreach", Icon: Send },
  { to: "/crm/documents", label: "Documents", Icon: FileText },
  { to: "/crm/notifications", label: "Notifications", Icon: Bell },
];

export const CRMLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/crm/login"); };

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="crm-layout">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col">
        <Link to="/crm" className="p-6 border-b border-slate-200 block">
          <div className="leading-none">
            <div className="font-display text-navy text-xl font-bold uppercase tracking-[0.18em]">Forte</div>
            <div className="font-display text-gold-dark text-sm font-bold uppercase tracking-[0.32em] mt-1">Realty</div>
          </div>
          <div className="text-[10px] tracking-[0.25em] text-slate-400 uppercase mt-3">Agent Portal · CRM</div>
        </Link>
        <nav className="flex-1 py-4">
          {nav.map(({ to, end, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 transition ${
                  isActive ? "border-gold bg-slate-50 text-navy font-semibold" : "border-transparent text-slate-600 hover:bg-slate-50"
                }`
              }
              data-testid={`crm-nav-${label.toLowerCase()}`}
            >
              <Icon className="w-4 h-4" strokeWidth={1.75} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-200">
          <div className="text-xs text-slate-500">Signed in as</div>
          <div className="text-sm font-semibold text-navy" data-testid="crm-user-name">{user?.name}</div>
          <div className="text-xs text-gold uppercase tracking-wider mt-0.5" data-testid="crm-user-role">{user?.role}</div>
          <button onClick={doLogout} className="mt-3 w-full inline-flex items-center justify-center gap-2 text-sm border border-slate-200 py-2 hover:bg-slate-50" data-testid="crm-logout">
            <LogOut className="w-4 h-4" /> Sign Out
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
};
